<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filtres</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Départements</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="departmentFilter"
            :options="departmentOptions"
            label="name"
            class="w-100"
            :clearable="false"
            :reduce="(val) => val.slug"
            @input="(val) => $emit('update:departmentFilter', val)"
            :selectable="(option) => option.uid != null"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Contrat</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="contractFilter"
            :options="contractOptions"
            class="w-100"
            :clearable="false"
            :reduce="(val) => val.value"
            :selectable="(option) => !option.value.includes('nothing_selected')"
            @input="(val) => $emit('update:contractFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    departmentFilter: {
      type: [String, null],
      default: null,
    },
    contractFilter: {
      type: [String, null],
      default: null,
    },
    departmentOptions: {
      type: Array,
      required: true,
    },
    contractOptions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
